import { AnalysisComponentDetailMetrics } from '../../../../../model/caf.interface'
import { BOX_BORDER_CLX } from '../../../../../modules/consts/caf'
import { IC_CAF_MTLD_CONTENT } from '../../../../../modules/images'
import { ICON_QUESTION_GRAY700 } from '../../../../../modules/svg/svg'
import { COLORS } from '../../../../../modules/vars'
import HighlightedText from '../../common/HighlightedText'

import { QIcon_question_outline } from '@repo/icons/index'
import Image from 'next/legacy/image'
import { useCafAnalysisAverageScoresV5 } from '../../../../../modules/apis/webview/caf'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import useMTLDDescriptionPopup from '../../../../student/portal/lessons/caf/CAFOverview/popup/useMTLDDescriptionPopup'
import { useWebviewModal } from '../../common/Modal/WebviewModal'

const ComplexityMTLDAccordion = ({ data }: { data: AnalysisComponentDetailMetrics }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const { showEditPopup, setShowEditPopup, MTLDDescriptionPopup } = useMTLDDescriptionPopup()
  const { data: scores, isLoading } = useCafAnalysisAverageScoresV5('mtld')
  const webveiwPopup = useWebviewModal()
  const onPressQuestionIcon = () => {
    if (isMobile) {
      webveiwPopup.show({
        id: 'mtld_popup',
        title: t(n_caf.complexity.tab3),
        body: <PopupContent />,
      })
    } else {
      setShowEditPopup(true)
    }
  }

  if (!scores || isLoading) {
    return <></>
  }

  const mtldList = [
    {
      title: t(n_caf.complexity.my_mtld),
      value: data.value,
      color: COLORS.PURPLE50,
    },
    {
      title: t(n_caf.complexity.percent_mtld),
      value: scores?.top_25_ratio.value,
      color: COLORS.YELLOW50,
    },
    {
      title: t(n_caf.complexity.tutor_mtld),
      value: scores?.native_ratio.value,
      color: COLORS.BLUE50,
    },
  ]

  if (isMobile) {
    return (
      <div className="mt-16">
        <div className="row-auto flex" onClick={onPressQuestionIcon}>
          <span className="text-14 mr-6 text-gray-700">{t(n_caf.complexity.mtld)}</span>
          <Image src={ICON_QUESTION_GRAY700} width={20} height={18} alt="question" />
        </div>
        <div className={`${BOX_BORDER_CLX} mt-[16px] flex py-[8px]  px-[4px]`}>
          {mtldList?.map((epcItem, idx) => (
            <p key={idx + 'epcItem'} className="flex-1 pl-[8px] first-of-type:border-r last-of-type:border-l">
              <div className="text-sBody pb-[8px]">{epcItem.title}</div>
              <HighlightedText color={epcItem.color} text={Number(epcItem.value).toFixed(2)} />
            </p>
          ))}
        </div>
      </div>
    )
  } else {
    return (
      <div>
        <div className="row-auto flex w-[424px] flex-row items-center" onClick={onPressQuestionIcon}>
          <span className="mr-4 text-[16px] font-bold text-black">{t(n_caf.complexity.mtld)}</span>
          <QIcon_question_outline color={COLORS.BLACK} width={20} height={20} />
        </div>
        <div className={`${BOX_BORDER_CLX} mt-[16px] flex h-[84px] bg-white py-[12px] px-[16px]`}>
          {mtldList?.map((epcItem, idx) => (
            <p key={idx + 'epcItem'} className="flex-1 pl-[8px] first-of-type:border-r last-of-type:border-l">
              <div className="pb-[8px] text-[16px] text-gray-700">{epcItem.title}</div>
              <HighlightedText color={epcItem.color} text={Number(epcItem.value).toFixed(2)} />
            </p>
          ))}
        </div>
        <MTLDDescriptionPopup />
      </div>
    )
  }
}

const PopupContent = () => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-start justify-start text-left">
      <Image src={IC_CAF_MTLD_CONTENT} width={265} height={84} alt="mtld" />
      <div className="h-[12px]" />
      {t(n_caf.complexity.mtld_modal_body)}
    </div>
  )
}

export default ComplexityMTLDAccordion
